import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import AddBossMode from './components/AddBossMode';
import BossModeTable from './components/BossModeTable';
import useRefetch from 'hooks/useRefetch';
import NumberOfResultsPerPageFilter from 'components/NumberOfResultsPerPageFilter';
import useNumberOfResultsPerPage from 'hooks/useNumberOfResultsPerPage';

import './BossModeAccounts.styles.scss';

type BossModeAccountsProps = {
  className?: string;
};

const BossModeAccounts: React.FC<BossModeAccountsProps> = (props) => {
  const { className } = props;

  const classes = classNames('boss-mode-accounts', className);

  const { refetchFlag, refetch } = useRefetch();

  const { limit, updateLimit } = useNumberOfResultsPerPage();

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div className="boss-mode-accounts__heading">
        <h1>{t('bossModeAccountsList')}</h1>

        <NumberOfResultsPerPageFilter limit={limit} updateLimit={updateLimit} />
        <AddBossMode onAddBossMode={refetch} />
      </div>

      <BossModeTable
        refetchFlag={refetchFlag}
        limit={limit}
        refetch={refetch}
      />
    </div>
  );
};

export default BossModeAccounts;
